import React from "react";
import { Badge } from "react-bootstrap";

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');

export const resolveUploadUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${UPLOAD_BASE}${path.startsWith('/') ? path : `/${path}`}`;
};

export const genderLabel = (gen) => {
  if (gen === 'm') return <Badge bg="primary">ชาย</Badge>;
  return <Badge bg="danger">หญิง</Badge>;
};

// '3' คือนักเรียนใหม่ที่ยังไม่ถูกจัดเข้าห้อง — แยกให้เห็น เพราะข้อมูลของคนกลุ่มนี้แก้ที่เมนูรับสมัคร
export const statusLabel = (status) => {
  if (status === '1') return <Badge bg="success">ปกติ</Badge>;
  if (status === '3') return <Badge bg="warning">นักเรียนใหม่</Badge>;
  if (status === '2') return <Badge bg="info">สำเร็จการศึกษา</Badge>;
  return <Badge bg="secondary">จำหน่าย</Badge>;
};

// General class: "ม. 1/16 (2569)". Strip the "ชั้นมัธยมศึกษาปีที่" prefix, keep only the level number.
export const generalClassLabel = (st) => {
  if (!st.c_class || !st.gen_room_no) return '-';
  const level = String(st.c_class).replace(/\D/g, '') || st.c_class;
  return `ม. ${level}/${st.gen_room_no}${st.gen_year ? ` (${st.gen_year})` : ''}`;
};

// Islamic class: "5 / A (AIP)". Program code shown only when it's not the General Program (GP).
export const islamicClassLabel = (st) => {
  if (!st.ic_class) return '-';
  let label = `${st.ic_class}`;
  if (st.isl_room_no) label += ` / ${st.isl_room_no}`;
  if (st.is_programCode && st.is_programCode !== 'GP') label += ` (${st.is_programCode})`;
  return label;
};

export const avatarInitial = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) return parts[0][0] + parts[1][0];
  return parts[0][0];
};

export const dormLabel = (st) => (
  st.dorm_name ? `${st.village_name ? st.village_name + ' เลขที่ ' : ''}${st.dorm_name}` : ''
);
